import { InvokeCallback, Sender } from "xstate";
import { withToken } from "@rentablo/api";
import {
  GetByQuoteProviderAndTickerQuoteProviderEnum,
  getByQuoteProviderAndTicker,
  getQuotesV2,
} from "@rentablo/api/apiv1";
import { TransactionWizardContext } from "../types/transactionWizardContext";
import { TransactionWizardEvent } from "../types/TransactionWizardEvent";

export const loadSymbol =
  (
    context: TransactionWizardContext,
    event: TransactionWizardEvent
  ): InvokeCallback<TransactionWizardEvent, TransactionWizardEvent> =>
  (callback) => {
    if (event.type !== "INIT_FROM_TICKER")
      throw new Error(`Invalid event type ${event.type}`);

    load(event.quoteProvider, event.tickerSymbol, callback);
  };

const load = async (
  quoteProvider: string,
  tickerSymbol: string,
  callback: Sender<TransactionWizardEvent>
) => {
  try {
    const [symbol, quoteList] = await Promise.all([
      withToken(getByQuoteProviderAndTicker)({
        quoteProvider:
          quoteProvider as GetByQuoteProviderAndTickerQuoteProviderEnum,
        id: tickerSymbol,
      }),
      withToken(getQuotesV2)({
        securityId: [tickerSymbol],
        quoteProvider,
      }),
    ]);

    const v2Quote = quoteList.quotes?.[0];

    if (v2Quote) {
      callback({
        type: "INIT_FROM_SYMBOL",
        symbol: {
          id: symbol.id ?? tickerSymbol,
          name: symbol.name ?? "",
          type: symbol.mappedType ?? "",
          quoteProvider: symbol.quoteProvider ?? quoteProvider,
          isin: symbol.isin,
          wkn: symbol.wkn,
          quote: v2Quote,
        },
      });
      return;
    }

    callback({
      type: "INIT_FROM_SYMBOL",
      symbol,
    });
  } catch (e) {
    callback({
      type: "SOMETHING_WRONG",
      error: e as AxiosApiError,
    });
  }
};
